<div class="modal-container">
  <div class="close-block">
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="closeModal()"
    >
      <i class="uil uil-times" aria-hidden="true"></i>
    </button>
  </div>

  <h3 class="mb-3">Comments</h3>

  <form [formGroup]="form">
    <sliqpay-textarea
      formControlName="comments"
      [rows]="5"
      testId="comment-textarea"
    ></sliqpay-textarea>

    <div class="row justify-content-end">
      <div class="col-md-4">
        <sliqpay-ui-button testId="save-btn" (pressed)="saveComment()" [loading]="loading()">
          Save</sliqpay-ui-button
        >
      </div>
    </div>
  </form>
</div>
